import { Modal, Button, Form } from "react-bootstrap";
import { useState, useEffect } from "react";
import { Notyf } from "notyf";

function ChangePasswordModal({ show, handleClose }) {
  const notyf = new Notyf();
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isBtnActive, setIsBtnActive] = useState(false);

  const onSubmit = (e) => {
    e.preventDefault();
    // fetch request to change password
    fetch(`${process.env.REACT_APP_API_BASE_URL}/users/update-password`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      body: JSON.stringify({ newPassword: newPassword }),
    })
      .then((response) => {
        if (response.ok) {
          notyf.success("Password changed successfully");
          setNewPassword("");
          setConfirmPassword("");
          handleClose();
        } else {
          notyf.error("Failed to change password");
        }
      })
      .catch((error) => {
        notyf.error("An error occurred");
        console.error("Error changing password:", error);
      });
  };

  useEffect(() => {
    if (newPassword === confirmPassword) {
      setIsBtnActive(true);
    } else {
      setIsBtnActive(false);
    }
  }, [newPassword, confirmPassword]);

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Change Password</Modal.Title>
      </Modal.Header>
      <Form onSubmit={onSubmit}>
        <Modal.Body>
          <Form.Group className="mb-3" controlId="newPassword">
            <Form.Label>New Password</Form.Label>
            <Form.Control
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
            />
          </Form.Group>
          <Form.Group className="mb-3" controlId="confirmPassword">
            <Form.Label>Confirm New Password</Form.Label>
            <Form.Control
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="primary" disabled={!isBtnActive} type="submit">
            Change Password
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}

export default ChangePasswordModal;
